/**
 * @typedef {Object} FeatureFlagProvider
 * @property {() => boolean} isAvailable
 * @property {() => Promise<void>} initialize
 * @property {(key: string, defaultValue: unknown, targeting?: Object) => Promise<unknown>} getValue
 *
 * @typedef {Object} FeatureFlagStore
 * @property {() => boolean} isAvailable
 * @property {() => Promise<boolean>} initialize
 * @property {(key: string, defaultValue: unknown, targeting?: Object) => Promise<unknown>} getValue
 */

/**
 * @param {FeatureFlagProvider} provider
 * @returns {FeatureFlagStore}
 */
export function createFeatureFlagStore(provider) {
  let initialization = null;

  function initialize() {
    if (!provider.isAvailable()) return Promise.resolve(false);

    if (!initialization) {
      initialization = provider.initialize()
        .then(() => true)
        .catch(() => false);
    }

    return initialization;
  }

  return {
    isAvailable() {
      return provider.isAvailable();
    },

    initialize,

    async getValue(key, defaultValue, targeting = {}) {
      if (!await initialize()) return defaultValue;

      try {
        return await provider.getValue(key, defaultValue, targeting);
      } catch (error) {
        return defaultValue;
      }
    }
  };
}
